export const kpis = {
  FACING: 1,
  FACING_MOYEN: 2,
  GAIN_FACING: 3,
  REFERENCES: 4,
  GAIN_REFERENCES: 9,
  DN: 10,
  GAIN_DN: 11,
  RUPTURE: 12,
  TAUX_RUPTURE: 13,
  POSITION: 14,
  POSITION_MARQUE: 15,
  PRIX: 16,
  LINEAIRE: 17,
  PDL: 18,
  GAIN_PDL: 19,
  VISITES: 26,
  RESPECT_FREQUENCES: 29,
  COUVERTURE: 34,
  ETIQUETTE: 36,
  PRES: 45,
  LINEAR_REF: 222,
  NB_BRI: 268,
  NB_PDC_VISITES: 282,
  LINEAR_CATEGORY: 284,
  LINEAR_BRAND: 290,
  PDL_BRAND: 437,
  MEA: 453,
  PLV: 484,
  SELL_OUT: 498,
  NB_VENDEURS: 499,
  NIV_FORMATION: 500,
  DATE_FORMATION: 501,
  PDL_FAMILY: 509,
  CMD_REASSORT_KPI_ID: 610,
  SAMPLE_PARODONTAX_KPI_ID: 618,
  //OLD
  PSR: 9999,
  TG_NEGO: 69,
  TG_CONSTAT: 70,
  TG_INST: 71,
  STOCK: 107,
  DEMO_AREA_OC: 108,
  DEMO_OC: 109,
  JANV: 110,
  FEV: 111,
  MARS: 112,
  VENDEUR: 113,
  RESP: 114,
  DISPLAY_HTC: 116,
  DEMO_HTC: 117,
  AVRIL: 118,
  MAI: 119,
  JUIN: 120,
  JUIL: 121,
  AOUT: 122,
  SEPT: 123,
  OCT: 124,
  NOV: 124,
  DEC: 124,
  MEAN_VISIT: 628
};



// WEBPACK FOOTER //
// src/configs/kpis.js